'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

var _components2 = require('components');

var _AgamaText = require('../../helpers/AgamaText');

var _utils = require('../../../api/actions/Db/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SongTools: {
    displayName: 'SongTools'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/SongTools/SongTools.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Swipeable from 'react-swipeable';
// import {  Glyphicon, Button} from 'react-bootstrap';
// import {Glyphicon} from 'react-bootstrap';

// import {SongToAgamaConverter} from './AgamaText';

// import { isSongsLoaded, loadSongs, isDocumentLoaded, loadDocument } from 'redux/modules/docs';
// import { changeSongChord } from 'redux/modules/docs';


var converter = new _AgamaText.SongToAgamaConverter(); // staci jeden spolecnej objekt
//const transposeChord2 = transposeChord;
//console.log('transposeChord is '+ transposeChord)


var SongTools = _wrapComponent('SongTools')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SongTools, _Component);

  function SongTools() {
    (0, _classCallCheck3.default)(this, SongTools);
    return (0, _possibleConstructorReturn3.default)(this, (SongTools.__proto__ || (0, _getPrototypeOf2.default)(SongTools)).apply(this, arguments));
  }

  (0, _createClass3.default)(SongTools, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          setUiProps = _props.setUiProps,
          xid = _props.xid,
          docs = _props.docs,
          path = _props.path,
          currentChord = _props.currentChord,
          mini = _props.mini; // eslint-disable-line no-shadow

      var ui = this.props.info.ui;

      // todo: tento kod je spolecny se 'Song' - sjednotit dle DRY !!!

      var documentCache = docs.documentCache;

      var document = xid ? documentCache[xid] : '';
      var text = document.text; // newText je lokální změněný dokument (neuložený na serveru)

      var changes = document.changes || {};
      var newText = changes.newText;

      var hasUnsavedChange = newText != null; // eslint-disable-line eqeqeq
      // visibleSourceText slouží jen pro zobrazení zdroje (text..originál ze serveru; newText..lokální vytvořený neuložený na serveru)
      var visibleSourceText = hasUnsavedChange ? newText : text;
      var docTextSize = 'docTextSize';
      /** je česká notace pro zobrazeni -bool*/
      var isTargetNotationCz = ui.song_notationCZ === false ? false : true;
      var increaseFontSize = function increaseFontSize() {
        var currentSize = ui[docTextSize] || 100;
        setUiProps(docTextSize, Math.min(currentSize + 5, 400));
      };
      var decreaseFontSize = function decreaseFontSize() {
        var currentSize = ui[docTextSize] || 100;
        setUiProps(docTextSize, Math.max(currentSize - 5, 10));
      };
      // const increaseChordKey = ()=>{
      //   changeSongChord(xid, 'C');
      // };

      var songObj = converter.convertToAgama(visibleSourceText, { targetNotation: isTargetNotationCz ? 'CZ' : 'INT' });
      // console.log(xid, changeSongChord, converter);
      // console.log(songObj.getChords());

      // todo: fce je pouzita také v TreeItem => DRY => sdilet
      var frindlyName = function frindlyName(name) {
        return name.replace(/\?/g, '');
      };
      /** tonina pisne v níž je zapsána, nebo null */
      var origBase = songObj.analysis.keyChord;
      // zkusíme vzit akord z url (zkontrolujeme jej)- jinak zpracujeme text písně
      /** cílová tonina z url*/
      var currentChord2 = currentChord;
      var carriedTransposeChord = function carriedTransposeChord(chord, targetOrInc) {
        return (0, _AgamaText.transposeChord)(chord.replace(/\is/g, '#'), targetOrInc, true, isTargetNotationCz ? 'CZ' : 'INT', isTargetNotationCz ? 'CZ' : 'INT');
      };
      var chordBaseTarget = (currentChord2 ? (carriedTransposeChord(currentChord2, 0) || {}).chord : null) || origBase;

      var getTargetBtn = function getTargetBtn(key, index) {
        var txt = key === origBase ? _react3.default.createElement(
          'u',
          null,
          key
        ) : _react3.default.createElement(
          'span',
          null,
          key
        );
        return _react3.default.createElement(
          _components2.ToolButton,
          { key: 'x' + index, linkTo: frindlyName(path) + key.replace(/\#/g, 'is'), nofollow: true, inGroup: mini ? false : true, inVerticalGroup: mini ? true : false, active: chordBaseTarget === key },
          txt
        );
      };
      var styles = require('./SongTools.scss');
      var extendTransposingBlock = null;
      var transposingBlock = null;

      if (chordBaseTarget) {
        //pokud ma akordy

        var visibleScale = (isTargetNotationCz ? 'C,D,E,F,G,A,H' : 'A,B,C,D,E,F,G').split(',');
        visibleScale.push(chordBaseTarget); //pridame cílový akord a ten o 1/2 tonu vyšší
        var upperOne = carriedTransposeChord(chordBaseTarget, 1);
        visibleScale.push(upperOne.chord);
        // const upperTwo =  carriedTransposeChord(chordBaseTarget, 2);
        // visibleScale.push(upperTwo.chord);
        var scale = (0, _utils.arrayUnique)((0, _AgamaText.getScale)(isTargetNotationCz ? 'CZ' : 'INT')).filter(function (x) {
          return visibleScale.indexOf(x) > -1;
        });
        var scaleButtons = scale.map(function (key, index) {
          return getTargetBtn(key, index);
        });

        var up = carriedTransposeChord(chordBaseTarget, 1).chord.replace(/\#/g, 'is');
        var down = carriedTransposeChord(chordBaseTarget, -1).chord.replace(/\#/g, 'is');
        transposingBlock = _react3.default.createElement(
          'span',
          null,
          _react3.default.createElement(_components2.ToolButton, { glyphIconName: 'arrow-up', linkTo: frindlyName(path) + up, nofollow: true, inVerticalGroup: mini ? true : false }),
          _react3.default.createElement(_components2.ToolButton, { glyphIconName: 'arrow-down', linkTo: frindlyName(path) + down, nofollow: true, inVerticalGroup: mini ? true : false })
        );
        extendTransposingBlock = _react3.default.createElement(
          'span',
          { className: styles.highDisplayOnly },
          scaleButtons
        );
      }
      return _react3.default.createElement(
        'div',
        { className: styles.songTools + (mini ? ' ' + styles.mini : '') },
        _react3.default.createElement(
          'div',
          null,
          extendTransposingBlock
        ),
        _react3.default.createElement(
          'div',
          null,
          mini ? transposingBlock : null,
          _react3.default.createElement(
            'span',
            null,
            _react3.default.createElement(_components2.ToolButton, { glyphIconName: 'text-size', onClick: increaseFontSize, inVerticalGroup: mini ? true : false }),
            _react3.default.createElement(_components2.ToolButton, { glyphIconName: 'text-size', onClick: decreaseFontSize, textClassName: 'mirror', inVerticalGroup: mini ? true : false })
          ),
          mini ? null : transposingBlock
        )
      );
    }
  }]);
  return SongTools;
}(_react2.Component), _class2.propTypes = {
  docs: _react2.PropTypes.object,
  info: _react2.PropTypes.object,
  path: _react2.PropTypes.string.isRequired,
  currentChord: _react2.PropTypes.string, // pokud je znam z URL, tak si muzeme usetrit praci se zjistovanim v jake tonine pisen je
  xid: _react2.PropTypes.string.isRequired,
  setUiProps: _react2.PropTypes.func.isRequired,
  mini: _react2.PropTypes.bool
}, _temp)) || _class));

exports.default = SongTools;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SongTools/SongTools.js
// module id = 1194
// module chunks = 0